import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import {
  AcaDocumentDto,
  ACA_DOCUMENTS_QUERY_KEY,
} from 'queries/useAcaDocumentsQuery';
import { useDownloadTaxDocumentQuery } from 'queries';
import { PsButtonTuner } from 'stencilSetup';
import { queryClient } from 'theSource/utils';

interface AcaDocumentProps {
  document: AcaDocumentDto;
  isCurrent?: boolean;
}

export const AcaDocument = ({
  document,
  isCurrent = false,
}: AcaDocumentProps) => {
  const { t } = useTranslation('pages.taxDocuments');

  const { isLoading: isLoadingDownload, refetch: downloadTaxDocument } =
    useDownloadTaxDocumentQuery({
      formId: document.form_id,
      onSuccess: () => {
        queryClient.invalidateQueries(ACA_DOCUMENTS_QUERY_KEY);
      },
    });

  const handleDownload = () => {
    downloadTaxDocument();
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
  };

  const textColor = isCurrent ? '#212935' : '#55575E';

  return (
    <div data-testId={`tax-form-${document.form_id}`} className="row mb-4">
      <div className="mr-3">
        <Typography size="13px" fontWeight="600" color={textColor}>
          {document.year}
        </Typography>
      </div>
      <div className="col">
        <Typography
          variant="body1"
          fontWeight={isCurrent ? '600' : '400'}
          color={textColor}
          className="mb-1"
        >
          {t('1095c')}
        </Typography>
        <Typography variant="body2" color={textColor}>
          {document.organization_name}
        </Typography>
        {document.form_download_date && (
          <Typography variant="body2" color={textColor}>
            {t('lastDownloaded', {
              date: formatDate(document.form_download_date),
              interpolation: { escapeValue: false },
            })}
          </Typography>
        )}
      </div>
      <div data-testId={`download-${document.form_id}`}>
        <PsButtonTuner
          buttonId={`download-${document.form_id}`}
          level="tertiary"
          onClick={handleDownload}
          label="Download"
          iconRight="download"
          disabled={isLoadingDownload}
        />
      </div>
    </div>
  );
};
